export default "__VITE_ASSET__CqjmDFhq__"